import abnormalTaskTracking from './view/abnormalTaskTracking.html'

export default {
    base: {
        state: 'declaration.declareASummary.abnormalTaskTracking',
        config: {
            url: '/abnormalTaskTracking',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'declaration.declareASummary.abnormalTaskTracking.list',
            title: '异常任务跟踪',
        },
    },
    list: {
        state: 'declaration.declareASummary.abnormalTaskTracking.list',
        config: {
            url: '/list',
            template: abnormalTaskTracking,
            controller: 'abnormalTaskTrackingCtrl',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/declaration/declareASummary/abnormalTaskTracking/routers.js